import { render, staticRenderFns, recyclableRender, components } from "./u-upload.vue?vue&type=template&id=49deb6f2&scoped=true&"
var renderjs
import script from "./u-upload.vue?vue&type=script&lang=js&"
export * from "./u-upload.vue?vue&type=script&lang=js&"
import style0 from "./u-upload.vue?vue&type=style&index=0&id=49deb6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49deb6f2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-upload/u-upload.vue"
export default component.exports